<template>
    <div class="tit_area">
        <strong class="txt_red" v-if="alertText">{{alertText}}</strong>
        <span class="period_txt" v-if="periodText">{{periodText}}</span>
        <p class="tit">{{title}}</p>
        <span class="writer">{{writer}}</span>
        <span class="date">{{changeSendDateFormat}} {{changeModifiedDateFormat}}</span>
    </div>
</template>

<script>
    import {toResponseViewFormat} from "@/common/utils/date.js";

    export default {
        name: "ResponseTitle",

        props: {
            alertText: {
            },

            periodText: {
            },

            title: {
                type: String,
                required: true
            },

            writer: {
                type: String,
                required: true
            },

            sendDateString: {
                type: String,
                required: true
            },
            modifyDateString: {
                type: String,
                required: false
            },
            isModified: {
                type: Boolean,
                required: true
            }
        },

        computed: {
            changeSendDateFormat() {
                return toResponseViewFormat(this.sendDateString)
            },
            changeModifiedDateFormat() {
              if (this.isModified) {
                  return "(" + toResponseViewFormat(this.modifyDateString) + " 수정)";
              }
              return "";
            },
        }
    }
</script>

<style scoped>

</style>